import { Component, OnInit } from '@angular/core';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { LogisticService, StockplaceItem } from '@app/services/logistic.service';

@Component({
    selector: 'tt-purch-receival-planning',
    templateUrl: './purch-receival-planning.component.html',
    styleUrls: ['./purch-receival-planning.component.css'],
})
export class PurchReceivalPlanningComponent extends ComponentBaseComponent implements OnInit {
    public get?: PurchReceivalPlanningGet;

    public grid?: GridOptions;

    public stockplaces: StockplaceItem[] = [];

    public purchOrderNoButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', onClick: () => this.grid?.gridfunc?.read?.(), type: 'primary' }];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {
        super();
    }

    private async loadStockplaces() {
        this.stockplaces = await this.logistic.getStockplaces();
    }

    private async loadPageGet() {
        this.get = (await this.datatask.Post(3604))[0];

        this.grid = new Grid()
            .setRememberId('purchreceivalplanning.grid')
            .setLoadDataFunction({ method: 3603, parameters: () => this.get! })
            .setConfig({ readAfterPrint: this.get?.refresh_after_print === '1' });
    }

    ngOnInit(): void {
        this.loadPageGet();
        this.loadStockplaces();
    }
}

interface PurchReceivalPlanningGet {
    stockplace_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    purch_order_no: string;
    refresh_after_print: '1' | '0';
    show_settings: '1' | '0';
}
